import { get, post, put, del, apiFetch } from '@/lib/api';
import type { WorkspaceFile } from '@/types';

export async function getFileTree(workspaceId: string): Promise<WorkspaceFile[]> {
  return get<WorkspaceFile[]>(`/ide/workspaces/${workspaceId}/files`);
}

export async function getFileContent(
  workspaceId: string,
  path: string
): Promise<string> {
  const encoded = encodeURIComponent(path);
  const res = await get<{ content: string }>(
    `/ide/workspaces/${workspaceId}/files/${encoded}`
  );
  return res.content;
}

export async function saveFile(
  workspaceId: string,
  path: string,
  content: string
): Promise<void> {
  const encoded = encodeURIComponent(path);
  await put(`/ide/workspaces/${workspaceId}/files/${encoded}`, { content });
}

export async function createFile(
  workspaceId: string,
  path: string,
  type: 'file' | 'directory'
): Promise<WorkspaceFile> {
  return post<WorkspaceFile>(`/ide/workspaces/${workspaceId}/files`, {
    path,
    type,
  });
}

export async function deleteFile(
  workspaceId: string,
  path: string
): Promise<void> {
  const encoded = encodeURIComponent(path);
  await del(`/ide/workspaces/${workspaceId}/files/${encoded}`);
}

export async function renameFile(
  workspaceId: string,
  oldPath: string,
  newPath: string
): Promise<void> {
  await apiFetch(`/ide/workspaces/${workspaceId}/files`, {
    method: 'PATCH',
    body: JSON.stringify({ oldPath, newPath }),
  });
}
